/* @flow */
import React from 'react'
import { compose, withProps, withStateHandlers } from 'recompose'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import { InfoBox } from 'react-google-maps/lib/components/addons/InfoBox'
import { I18n } from 'react-redux-i18n'

import './style.css'
import SceneMarker from './SceneMarker'

const map = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyA-B0dh_-HoBK5IAp8s0JPbJbwpMiJWVoA&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: window.innerHeight + 'px' }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withStateHandlers(() => ({
    isOpenIdx: -1,
  }), {
    onAedToggleOpen: () => (idx) => {
      console.warn('toggle open: ', idx)
      return {
      isOpenIdx: idx,
    }}
  }),
  withScriptjs,
  withGoogleMap
)((props) => <GoogleMap
  defaultZoom={props.zoom}
  center={props.center}>
  {props.scenes.map(scene =>
    <SceneMarker key={scene.name[props.locale] || scene.name}
      selected={props.selected === scene.name}
      locale={props.locale}
      locationName={props.locationName}
      scene={scene}
      divingMode={props.divingMode}
      onClick={props.clickHandler}
      onInfoClick={props.infoClickHandler}
    />
  )}
  {props.aedList.map((aed, idx) =>
    <Marker key={aed.name}
      position={aed.latlng}
      onClick={() => props.onAedToggleOpen(idx)}
      icon={{
        url:'/aed.png',
        size: new window.google.maps.Size(32, 32)
      }}
    >
      {props.isOpenIdx === idx && <InfoBox
        onCloseClick={() => props.onAedToggleOpen(-1)}
      >
        <div className="default-container">
          <div className="title">
            {aed.name}
          </div>
          <div className="subtitle">
            {aed.address}
          </div>
          <div className="highlight">
            {I18n.t('position') + ": " + aed.position}
          </div>
        </div>
      </InfoBox>}
    </Marker>
  )}
</GoogleMap>)

export default map


// WEBPACK FOOTER //
// ./src/components/Map/index.js